const tablePages = new Map();

export const getTablePage = (key) => tablePages.get(key) || 0;

export const setTablePage = (key, page) => {
  if (!key || !Number.isInteger(page) || page < 0) return;
  tablePages.set(key, page);
};
